import { Link } from "react-router-dom";
import { Printer, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const MP = { amazon: "text-[#F59E0B]", flipkart: "text-[#60A5FA]", firstcry: "text-[#F472B6]" };

export const PendingBox = ({ stats, warehouses, onPrintAll, onPrintUnmatched }) => {
  const pending = stats?.pending ?? 0;
  const unmatched = warehouses.find((w) => w.warehouse_id === "UNMATCHED")?.pending ?? 0;
  const ready = Math.max(0, pending - unmatched);
  const top = warehouses.filter((w) => w.warehouse_id !== "UNMATCHED" && w.pending > 0).sort((a, b) => b.pending - a.pending).slice(0, 5);
  return (
    <div className="space-y-3" data-testid="pending-box">
      <h2 className="font-heading text-lg font-bold uppercase tracking-tight sm:text-xl">Labels pending to be printed</h2>
      <div className={cn("flex h-[calc(100%-2.25rem)] flex-col rounded-md border bg-[#111827] p-5", pending > 0 ? "border-amber-700/60" : "border-emerald-700/50")}>
        <div className="flex items-start justify-between">
          <div>
            <div className="font-heading text-5xl font-extrabold tracking-tight text-amber-300 sm:text-6xl" data-testid="pending-box-count">{pending}</div>
            <div className="mt-1 font-mono text-[11px] uppercase tracking-widest text-slate-400">{ready} ready · {unmatched} unmatched</div>
          </div>
          <Clock className="h-6 w-6 text-amber-400/70" />
        </div>
        <div className="mt-3 space-y-1 font-mono text-xs">
          {["amazon", "flipkart", "firstcry"].map((m) => (
            <div key={m} className="flex justify-between"><span className={cn("uppercase tracking-widest", MP[m])}>{m}</span><span className="text-slate-300">{stats?.pending_by_marketplace?.[m] ?? 0}</span></div>
          ))}
        </div>
        {top.length > 0 && (
          <div className="mt-3 border-t border-slate-800 pt-3 font-mono text-xs text-slate-400">
            {top.map((w) => <div key={w.warehouse_id} className="flex justify-between"><span className="text-blue-300">{w.warehouse_id}</span><span>{w.pending}</span></div>)}
          </div>
        )}
        <div className="mt-auto flex flex-wrap gap-2 pt-4">
          <Button data-testid="pending-box-print-all" className="flex-1 bg-blue-600 hover:bg-blue-700" disabled={!pending} onClick={onPrintAll} title="Prints matched labels first (Warehouse → SKU), unmatched last"><Printer className="mr-2 h-4 w-4" /> Print all {pending}</Button>
          <Button data-testid="pending-box-print-unmatched" variant="outline" className="border-red-700/70 text-red-200 hover:bg-red-900/40" disabled={!unmatched} onClick={onPrintUnmatched}><Printer className="mr-2 h-4 w-4" /> Print {unmatched} unmatched</Button>
          <Button asChild variant="outline" className="border-slate-700 bg-transparent hover:bg-slate-800"><Link to="/labels?status=pending&date=all" data-testid="pending-box-view"><ArrowRight className="h-4 w-4" /></Link></Button>
        </div>
      </div>
    </div>
  );
};
